{
  "status": {
    "IN_SERVICE": "In service",
    "OUT_OF_ORDER": "Out of order",
    "REMOVED": "Removed",
    "REPLACED": "Replaced"
  },
  "condition": {
    "GOOD": "Good",
    "FAIR": "Fair",
    "POOR": "Poor"
  },
  "yes": "Yes",
  "no": "No",
  "notSet": "Not recorded",
  "onSite": "On the site itself",
  "wholeSite": "Whole site",
  "fields": {
    "type": "Asset type",
    "place": "Place",
    "tag": "Tag",
    "brand": "Brand",
    "model": "Model",
    "brandModel": "Brand and model",
    "serial": "Serial number",
    "installedOn": "Installed on",
    "warrantyUntil": "Warranty until",
    "condition": "Condition",
    "product": "Catalogue product",
    "notes": "Notes",
    "keyField": "Key detail",
    "lastService": "Last service",
    "status": "Status",
    "count": "How many",
    "position": "Position",
    "warranty": "Warranty"
  },
  "place": {
    "search": "Search places",
    "empty": "No place matches."
  },
  "list": {
    "title": "Assets",
    "titleAt": "Assets at {{place}}",
    "add": "Add asset",
    "addSeveral": "Add several identical",
    "copy": "Copy assets to places…",
    "printLabels": "Print labels",
    "printSelected_one": "Print {{n}} label",
    "printSelected_other": "Print {{n}} labels",
    "more": "More asset actions",
    "moreFor": "More actions for {{name}}",
    "selectAll": "Select all assets",
    "select": "Select {{name}}",
    "actions": "Actions",
    "empty": "No assets here yet.",
    "emptyBody": "Add the assets installed here: AC units, extinguishers, pumps.",
    "neverServiced": "Not yet",
    "open": "Open",
    "edit": "Edit",
    "reportFault": "Report fault",
    "printLabel": "Print label",
    "showFinal": "Show replaced and removed",
    "openJob": "Open job {{number}}",
    "search": "Search tag, place, position, brand or model",
    "clearSearch": "Clear search",
    "outOfOrderOnly": "Out of order only",
    "emptyFiltered": "No asset matches.",
    "clearFilters": "Clear filters",
    "emptyArchived": "This site is archived: no assets can be added to it."
  },
  "drawer": {
    "addTitle": "Add asset",
    "bulkTitle": "Add several identical assets",
    "bulkDescription": "Each one gets its own tag, numbered from the type's prefix.",
    "editTitle": "Edit {{tag}}",
    "replaceTitle": "Replace {{tag}}",
    "replaceDescription": "The new unit goes in the same place. {{tag}} stays in the register as replaced, with its history.",
    "sections": {
      "what": "What it is",
      "identity": "Where and which",
      "dates": "Dates and condition",
      "more": "Product and notes"
    },
    "chooseType": "Choose a type",
    "noTypes": "No asset types yet. Ask an administrator to add them in Settings › Asset types.",
    "tagHint": "Leave it empty to number it automatically.",
    "tagAuto": "Automatic ({{prefix}}-…)",
    "tagAutoPlain": "Automatic",
    "countHint": "Up to {{max}} at once.",
    "productHint": "The catalogue model, when it is one we sell.",
    "productPlaceholder": "Search the catalogue…",
    "clearProduct": "Clear",
    "replaceNote": "Why it was replaced",
    "replaceNotePlaceholder": "Compressor failed, beyond repair",
    "save": "Save asset",
    "saveBulk_one": "Add {{n}} asset",
    "saveBulk_other": "Add {{n}} assets",
    "saveReplace": "Replace asset",
    "errors": {
      "type": "Choose the asset type.",
      "required": "Required.",
      "number": "Enter a number.",
      "choice": "Choose one of the options.",
      "count": "Enter how many, from 1 to {{max}}.",
      "tagFormat": "Use letters, digits and . _ - / only.",
      "tagTaken": "Another asset already has this tag. Choose another, or leave it empty for an automatic one.",
      "yesNo": "Choose yes or no.",
      "date": "Enter a date.",
      "text": "Enter text.",
      "warranty": "The warranty can’t end before the install date.",
      "placeArchived": "This place is archived. Choose another.",
      "typeArchived": "This asset type is archived. Choose another.",
      "variant": "Choose a catalogue product.",
      "productSerial": "The serial number isn’t one of this catalogue product.",
      "siteArchived": "This site is archived: restore it before adding or moving its assets.",
      "tooLong": "Too long: shorten it.",
      "check": "Check this value."
    },
    "positionHint": "Which one it is where several share a place.",
    "positionPlaceholder": "Bedroom 2",
    "discardTitle": "Discard unsaved changes?",
    "discardBody": "What you entered in this asset will be lost.",
    "discard": "Discard changes",
    "keepEditing": "Keep editing",
    "noTypesCreate": "No asset types yet. Add one with “New asset type” in the list above.",
    "siteArchivedPlace": "The site is archived: its assets stay where they are."
  },
  "toast": {
    "added": "Asset {{tag}} added",
    "addedMany_one": "{{n}} asset added",
    "addedMany_other": "{{n}} assets added",
    "updated": "Asset {{tag}} saved",
    "replaced": "{{tag}} replaced"
  },
  "statusDialog": {
    "note": "Note",
    "noteRequired": "Say why it was removed.",
    "outOfOrder": {
      "title": "Mark {{tag}} out of order?",
      "body": "It stays in the register and in its place, flagged until it is back in service.",
      "confirm": "Mark out of order",
      "done": "{{tag}} marked out of order",
      "placeholder": "Not cooling; waiting for a compressor"
    },
    "inService": {
      "title": "Put {{tag}} back in service?",
      "body": "It counts as working again.",
      "confirm": "Back in service",
      "done": "{{tag}} is back in service",
      "placeholder": "Repaired on visit SJ-00012 · 2"
    },
    "remove": {
      "title": "Remove {{tag}}?",
      "body": "A removed asset stays in the history but can't change again. To put in a new unit, use Replace instead.",
      "confirm": "Remove asset",
      "done": "{{tag}} removed",
      "placeholder": "Taken out by the customer"
    }
  },
  "copy": {
    "title": "Copy the assets of {{place}}",
    "description": "Its assets in service are copied to each place you choose: same type, brand, model and details, with new tags. Serials, dates and links are not copied.",
    "targets": "Copy to",
    "clear": "Clear",
    "summary_one": "{{n}} place",
    "summary_other": "{{n}} places",
    "submit": "Copy assets",
    "nothing": "No asset here is in service, so there is nothing to copy.",
    "chooseTargets": "Choose at least one place.",
    "willMake_one": "Makes {{n}} asset.",
    "willMake_other": "Makes {{n}} assets.",
    "limit": "At most {{max}} assets in one copy.",
    "done_one": "{{n}} asset copied",
    "done_other": "{{n}} assets copied",
    "clearSearch": "Clear the search",
    "byLevel": "Choose a whole level",
    "everyLevel": "Every {{level}} ({{n}})",
    "everyDepth": "Every place at level {{depth}} ({{n}})",
    "selectShown_one": "Select the {{n}} shown",
    "selectShown_other": "Select all {{n}} shown",
    "perPlace": "Assets in service here, copied to each place you choose: {{n}}.",
    "tooMany": "That makes {{n}} assets: at most {{max}} in one copy. Choose fewer places.",
    "errors": {
      "tooMany": "That would make more than {{max}} assets in one copy. Choose fewer places.",
      "archived": "Some of these places were archived meanwhile. Choose others.",
      "itself": "Choose places other than this one.",
      "check": "Check the places chosen."
    }
  },
  "page": {
    "title": "Asset",
    "registerOff": "The asset register is switched off in Settings › Service jobs. Its records stay, but they can’t change.",
    "final": {
      "REPLACED": "This asset was replaced. It stays in the register with its history and no longer changes.",
      "REMOVED": "This asset was removed. It stays in the register with its history and no longer changes."
    },
    "openSuccessor": "Open {{tag}}",
    "identity": "Identity",
    "details": "{{type}} details",
    "noDetails": "This type has no extra details.",
    "history": "History",
    "photos": "Photos and documents",
    "sections": "Asset sections",
    "underWarranty": "Until {{date}}",
    "warrantyEnded": "Ended {{date}}",
    "lastService": "{{date}} · {{number}}",
    "replaces": "Replaces",
    "replacedBy": "Replaced by",
    "actions": {
      "reportFault": "Report fault",
      "edit": "Edit",
      "outOfOrder": "Mark out of order",
      "backInService": "Back in service",
      "replace": "Replace",
      "printLabel": "Print label",
      "remove": "Remove"
    },
    "openJob": "Open job",
    "detailsFailed": "The type’s details could not be loaded."
  },
  "history": {
    "empty": "Nothing has happened to this asset yet.",
    "job": "Job",
    "visit": "Visit",
    "visitOn": "Visit on {{date}}",
    "workPerformed": "Work performed",
    "findings": "Findings",
    "statusChanged": "Status changed",
    "replacedBy": "Replaced by",
    "replaces": "Replaces",
    "created": "Added to the register",
    "note": "Note",
    "by": "by {{name}}",
    "check": "Check",
    "results": "Readings and checks",
    "checkReason": "Why",
    "faultJob": "Fault job"
  },
  "labels": {
    "title": "Asset labels",
    "subtitle": "Each tag as a barcode, with the type, the site and the place.",
    "back": "Back",
    "print_one": "Print {{n}} label",
    "print_other": "Print {{n}} labels",
    "size": "Label size",
    "sizes": {
      "roll50x25": "Roll 50 × 25 mm",
      "roll38x25": "Roll 38 × 25 mm",
      "a4x24": "A4 sheet, 24 labels (70 × 37 mm)"
    },
    "copies": "Copies of each",
    "copiesHint": "From 1 to {{max}}.",
    "none": "No assets to print.",
    "unprintable_one": "{{n}} tag can't be drawn as a barcode.",
    "unprintable_other": "{{n}} tags can't be drawn as a barcode.",
    "preview": "Label preview",
    "language": "Label language",
    "languageHint": "Type and place names print in this language.",
    "copiesError": "Enter a whole number from 1 to {{max}}.",
    "chooseAssets": "Choose the assets to print: open a site, tick its assets and choose Print labels.",
    "openSites": "Open sites",
    "retry": "Try again",
    "someFailed_one": "{{n}} asset could not be loaded: its label is missing.",
    "someFailed_other": "{{n}} assets could not be loaded: their labels are missing.",
    "truncated": "Printing the first {{max}} of {{total}} assets. Print the rest place by place."
  },
  "lookup": {
    "label": "Find asset by tag",
    "placeholder": "Tag, e.g. AC-00012",
    "submit": "Find",
    "notFound": "No asset with that tag.",
    "description": "Type or scan a tag to open its asset."
  },
  "job": {
    "place": "Place in the site",
    "placeHint": "Where in the site the work is.",
    "assets": "Assets",
    "noAssetsHere": "No assets recorded here",
    "assetsPlaceholder": "Choose the assets",
    "assetsSearch": "Search tag or type",
    "assetsEmpty": "No asset matches.",
    "assetsClear": "Clear",
    "assetsSummary_one": "{{n}} asset",
    "assetsSummary_other": "{{n}} assets",
    "groupChecked": "{{n}} checked",
    "chosen": "Chosen assets",
    "remove": "Remove {{name}}",
    "searching": "Searching…",
    "cutOff": "Showing the first {{n}} of {{total}}: type more to narrow the list.",
    "siteChanged": "The place and assets were cleared: they belonged to the other site.",
    "assetsFailed": "The assets could not be loaded.",
    "facts": {
      "warranty": "Under warranty until {{date}}",
      "openJob": "Open job {{number}}",
      "openJobs_one": "Open job {{number}} and {{n}} more",
      "openJobs_other": "Open job {{number}} and {{n}} more",
      "lastService": "Last serviced {{date}}"
    }
  },
  "visit": {
    "title": "Assets",
    "accessNotes": "Access",
    "none": "No asset is named on this job."
  },
  "errors": {
    "CODE_TAKEN": "That code is already used. Choose another.",
    "TAG_TAKEN": "Another asset already has this tag. Choose another, or leave it empty for an automatic one.",
    "PLACE_TOO_DEEP": "That would go deeper than the site's levels allow.",
    "SITE_LIMIT": "The site has reached its limit of places.",
    "PLACE_NAME_TAKEN": "A place beside it already has that name.",
    "PLACE_CYCLE": "A place can't move under itself or a place inside it.",
    "NOT_OF_SITE": "That place or asset belongs to another site. Choose one of this site's.",
    "PLACE_HAS_ASSETS": "Assets in service are still there. Move or remove them first.",
    "ASSET_FINAL": "This asset was replaced or removed, so it no longer changes.",
    "TEMPLATE_IN_USE": "Sites use this template, so its number of levels can't change.",
    "IMPORT_STALE": "The file or the site changed since the preview. Preview it again.",
    "ASSETS_OFF": "The asset register is switched off in Settings › Service jobs."
  },
  "fault": {
    "openJob": "{{number}} is already open on this asset",
    "openJobBody": "You can still open a new job if this is another fault.",
    "openJobLink": "Open {{number}}",
    "occupant": "Occupant:",
    "useOccupant": "Use the occupant as contact"
  }
}
